export function formatRupiah(amount: number | null | undefined) {
  if (amount == null) return '-';
  return `Rp ${amount.toLocaleString('id-ID')}`;
}
